import FetchService from "./Shared/FetchService";
const BASE_URL = "/aviso/pipelineStatus";
export default class PipelineStatusService {
    static search(search, options = {}) {
        return FetchService.getSingleResponse(BASE_URL + "/search", {
            ids: search.ids,
            query: search.query,
            max: options.max,
            offset: options.offset,
            sort: options.sort,
            order: options.order,
        });
    }
}
